var packageInfo = require('./package.json');

require('./lib/index').setPkgVersion(packageInfo.version);

module.exports = require('./lib/index');


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/index.js